export default __webpack_public_path__ + "static/media/icon-arror.b7e45bb6.svg";